import { render } from "./form-land-modal.vue?vue&type=template&id=8d069b28&scoped=true"
import script from "./form-land-modal.vue?vue&type=script&lang=js"
export * from "./form-land-modal.vue?vue&type=script&lang=js"

import "./form-land-modal.vue?vue&type=style&index=0&id=8d069b28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d069b28"]])

export default __exports__